// extracted by mini-css-extract-plugin
var _1 = "errors-DjGXx";
export { _1 as "errors" }
